export const CASES = {
  UPDATE_UPDATE_ENGINE: "UPDATE_UPDATE_ENGINE",
  UPDATE_UPDATE_ENGINE_SEARCH_FORM: "UPDATE_UPDATE_ENGINE_SEARCH_FORM",
  CLEAR_UPDATE_ENGINE: "CLEAR_UPDATE_ENGINE",
  CLEAR_JOB_VIEW_MODAL: "CLEAR_JOB_VIEW_MODAL",
};

// Range value to fetch all items for export
export const EXPORT_ALL_RANGE = "0,999999";
